module.exports = __webpack_public_path__ + "static/img/profile.2c8c5d6.png";